import http from "@/utils/request";

const merchant = {
  list: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderDCService.queryDCSelectResult",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {
        10000001: "内部异常",
      },
    }),
  merchantAuthorize: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderDCService.providerChannelPageQuery",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {
        10000001: "内部异常",
        10000002: "参数错误",
      },
    }),
  merchantTypes: () =>
    http.sendRequest({
      METHOD_NAME: "enumService.getChannelTypes",
      SECURITY_TYPE: "UserLogin",
    }),
  downloadMerchantAuth: (data) =>
    http.sendRequest({
      METHOD_NAME:
        "venderStockoutService.submitDownloadProviderChannelAuthTask",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {
        12000001: "未找到用户",
        19000001: "下载服务内部异常",
        19000002: "文件类型不合法",
        19000003: "已经有下载报表的请求,请等待",
        19000007: "不支持面单下载",
      },
    }),
  updateMerchantAuth: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderDCService.overrideChannelBrandAuth",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {
        10000001: "内部异常",
        10000002: "参数错误",
      },
    }),
  merchantBrandAuth: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderDCService.queryDCBrandLevelConfigItemList4Page",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {
        10000001: "内部异常",
        10000002: "参数错误",
      },
    }),
  supplyPrice: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderSkuService.querySkuSupplyPriceList4Page",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  downloadSupplyPriceTask: (data) =>
    http.sendRequest({
      METHOD_NAME:
        "venderChannelSupplyPriceService.submitDownloadChannelSupplyPriceTask",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  previewImportChannelSupplyPrice: (data) =>
    http.sendRequest({
      METHOD_NAME:
        "venderChannelSupplyPriceService.previewImportChannelSupplyPrice",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  batchImportChannelSupplyPrice: (data) =>
    http.sendRequest({
      METHOD_NAME:
        "venderChannelSupplyPriceService.batchImportChannelSupplyPrice",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  batchUpdateSupplyPrice: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderChannelSupplyPriceService.batchUpdateSupplyPrice",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  spplyPriceQuery: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderChannelSupplyPriceService.pageQuery",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  venderChannelList: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderDCService.queryVenderChannel4PageResult",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  downloadVenderChannel: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderDCService.submitDownloadVenderChannelTask",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
};

export default merchant;
